import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type {
  ICheckboxMapperProps,
  CheckboxDefinition,
  ICheckboxStateValues,
} from '../Checkbox.types';

export const props = withCompInfo<
  ICheckboxMapperProps,
  CheckboxDefinition,
  ICheckboxMapperProps
>()(
  [
    'fullNameCompType',
    'language',
    'pagesMap',
    'compId',
    'mainPageId',
    'experiments',
    'trackClicksAnalytics',
  ],
  (compProps, carmiData) => {
    return {
      ...carmiData,
      ...compProps,
    };
  },
);

const stateRefs = withStateRefsValues<keyof ICheckboxStateValues>([
  'reportBi',
  'pageId',
]);

export default createComponentMapperModel({ props, stateRefs });
